import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const divider = {
  marginBottom: spacing.std,
  marginTop: spacing.std,
} as const;

export const title = {
  marginBottom: spacing.std,
  color: colors.blueDusk.standard,
} as const;

export const container = {
  width: "100%",
  marginBottom: spacing.sm,
} as const;

export const barContainer = {
  position: "relative",
  width: "100%",
  height: 10,
  marginTop: 5,
} as const;

export const legendRow = {
  display: "flex",
  alignItems: "center",
  fontSize: 14,
} as const;

export const focusHours = {
  fontWeight: 600,
  margin: "0 5px",
} as const;

export const goalIndicator = {
  position: "absolute",
  top: 0,
  bottom: 0,
  borderLeft: `1px dashed ${greys.slate}`,
} as const;

const baseLabel = {
  fontSize: 12,
  fontWeight: 600,
  marginLeft: "auto",
} as const;

export const goodLabel = {
  ...baseLabel,
  color: colors.green.darker,
} as const;

export const badLabel = {
  ...baseLabel,
  color: colors.red.standard,
} as const;

export const tooltipIcon = {
  color: greys[3],
} as const;
